<template>
  <b-card>
    <b-row class="px-1 align-items-center justify-content-between">
      <h5>مشاريع التعاون مع منظمات الأمم المتحدة</h5>
      <!-- <b-button
        size="sm"
        to="/un-coop/projects/new"
        variant="success"
        v-can="{ slug: $route.meta.slug, action: 'C' }"
      >
        <div class="d-flex">
          <feather-icon icon="PlusIcon" class="mr-25" />
          إضافة
        </div>
      </b-button> -->
    </b-row>
    <hr />
    <data-table
      v-can="{ slug: $route.meta.slug, action: 'S' }"
      ep="v2/co-op/projects"
      id="projects"
      :fields="tableFields"
      hover
      ref="projectsTable"
      @row-clicked="onRowClicked"
    >
      <template #cell(date)>
        {{
          new Date().toLocaleDateString("ar-SY", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        }}
      </template>
      <template #cell(actions)="{ item }">
        <div class="d-flex justify-content-end">
          <b-button
            v-if="canAddTransaction"
            v-can="{ slug: $route.meta.slug, action: 'D' }"
            @click="onDeleteClicked(item.id)"
            variant="flat-danger"
            class="btn-icon rounded-circle"
          >
            <feather-icon icon="Trash2Icon" />
          </b-button>
        </div>
      </template>
    </data-table>
  </b-card>
</template>

<script>
import { BCard, BRow, BButton } from "bootstrap-vue";
import DataTable from "@/components/data-table";
import { mapGetters, mapActions } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BRow,
    DataTable,
    BButton,
  },
  data() {
    return {
      tableFields: [
        { key: "id", label: "المعرف" },
        { key: "code", label: "رقم المشروع" },
        { key: "name", label: "اسم المشروع" },
        { key: "date", label: "التاريخ" },
        { key: "actions", label: " " },
      ],
    };
  },
  methods: {
    ...mapActions("UNCoop", ["deleteProject"]),
    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف مشروع التعاون", {
          title: "تأكيد الحذف",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deleteProject(id).then(() => {
              this.$refs.projectsTable.refreshTable();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "تم حذف المشروع بنجاح ",
                  icon: "CheckSquareIcon",
                  variant: "success",
                },
              });
            });
          }
        });
    },
    onRowClicked(val) {
      this.$router.push(`/un-coop/projects/${val.id}`);
    },
  },
  computed: {
    ...mapGetters("UNCoop", ["working"]),
    
    ...mapGetters("NgoProfile", [ "canAddTransaction"]),
  },
};
</script>
